import loadFunction from './config/functions/load-function';
import { Components } from './technology/components'
import { particle } from './technology/graphicsLibrary/particle.js'
// import { DeviceController } from './technology/graphicsLibrary/deviceController.js'
// import { ThreeModel } from './technology/graphicsLibrary/3DModel';
// import { AMap } from './technology/graphicsLibrary/AMap';

import { DeviceController, ThreeModel, AMapLibs, qrcode } from './technology/graphicsLibrary/index'

import * as echarts from 'echarts'
import { jsToken } from "../types/config";

import { getComponentCategory, delComponentCategory, editComponentCategory, getComponent, editComponent, delComponent } from './apis/technology.js'

/**
 * 工艺拓扑图工具
 */
// 1. 导入正式绘画引擎
import * as TopologyEngine from './technology/topology/topology.js';

// 开发模式绘图引擎
// import * as TopologyEngine from './technology/dev/topology.js/src/index';

import { EventEmitter } from '../EventEmitter'
import { uuid, storage, encrypt } from '../utils/tools'



/**
 * @typedef funcModules
 * @type {object}
 * @property { string } name 函数模块名
 * @property { string } desc 描述
 * @property { string } key 函数唯一标识
 * @property { any } value 消息名，用于监听
 * @property { function } func 函数模块主体
 */


/**
 * @type {TechnologyTopology}
 */
let self = null;

const decryptKey = 'hexu';

let globalFunctions = [];


/**
 * @class TechnologyTopology
 * @classdesc 工艺图服务
 */
export default class TechnologyTopology extends EventEmitter {
    constructor(proc) {
        super()
        this.jsToken = jsToken;
        this.proc = proc;
        this.$root = proc.$root;
        this.data = proc.data;
        this.data.spriteEvents = [] //事件列表
        this.data.spriteFremas = [] //动画列表

        Object.keys(TopologyEngine).forEach(key => {
            if (!this[key]) {
                this[key] = TopologyEngine[key]
            }
        })
        self = this;
        this.TopoComponents = new Components(this)

    }
    /**
     * @type {Components}
     */
    TopoComponents = null;

    /**
     * 获取函数模块列表
     * @returns {Object<funcModules>}
     */
    getFunctions() {
        return loadFunction;
    }

    /**
     * 全局函数
     * @property
     */
    get globalFunctions() {
        return globalFunctions;
    }

    set globalFunctions(val) {
        if (!Array.isArray(val)) return;
        const setArr = new Set([...globalFunctions, ...val])

        globalFunctions = [...setArr]
    }
    /**
     * 组件控制
     * @type {object}
     * @property {function} getCate 获取组件分类
     * @property {function} delCate 删除组件分类
     * @property {function} putCate 修改组件分类
     * @property {function} getComponent 获取组件
     * @property {function} putComponent 修改组件
     */
    components = {
        async getCate() {
            return getComponentCategory()
        },
        async delCate(id) {
            return delComponentCategory(id)
        },
        async putCate(id, data) {
            return editComponentCategory(id, data)
        },
        async getComponent(CraftComponentCatalogId) {
            return getComponent(CraftComponentCatalogId)
        },
        async putComponent(CraftComponentCatalogId, id, data) {
            return editComponent(CraftComponentCatalogId, id, data)
        },
        async delComponent(CraftComponentCatalogId, id) {
            return delComponent(CraftComponentCatalogId, id)
        }
    }

    /**
     * 设置初始化模块
     * @param {Array | string} moduleName 模块名称
     */
    setInitJs(moduleName) {
        let name = ''
        if (Array.isArray(moduleName)) {
            name = moduleName.join(',')
        } else {
            name = moduleName
        }
        this.store.data.initJs = `globalThis.callFunc('${name}')`
        this.store.data.initJsName = name;
    }
    /**
     * 清空初始化模块
     */
    clearInitJs() {
        this.store.data.initJs = ''
        this.store.data.initJsName = '';
    }

    MQTT = null

    /**
     * 订阅mqtt
     * @param {object} param 
     */
    subscribe(topic, cb) {
        if (!topic) return console.warn('没有主题');
        this.MQTT = this.proc.make('MQTT');
        this.MQTT.subscribe(topic)
        if (cb) {
            this.MQTT.on('subscribe.success', cb)
        }
        // this.stageCanvas.connectMqtt(param)
    }

    /**
     * 设置消息数据，用于发送mqtt消息等
     */
    set msgData(val) {
        let active = this.store.active[0];
        active.sendMsgData = val;
    }
    /**
     * 获取消息数据
     */
    get msgData() {
        let active = this.store.active[0];
        return active.sendMsgData
    }

    /**
     * 设置自定义数据
     */
    set customData(val) {
        if (!this.store.data.CustomData) {
            this.store.data.CustomData = {}
        }
        if (typeof val !== 'object') {
            console.error('Not a object')
            return;
        }
        Object.keys(val).forEach(key => {
            let CustomDataActive = this.store.data.CustomData[this.store.active[0].id]
            if (!CustomDataActive) {
                this.store.data.CustomData[this.store.active[0].id] = {}
            }
            this.store.data.CustomData[this.store.active[0].id][key] = val[key];
        })

    }
    /**
     * 获取自定义数据
     */
    get customData() {
        let CustomData = this.store.data.CustomData || {}
        return CustomData[this.store.active[0].id] || {}
    }


    /**
     * 添加函数模块
     * @param { Object<funcModules> } modulesObj 添加的模块对象 {@link funcModules}
     */
    set addFunction(modulesObj) {
        if (!modulesObj.key) {
            modulesObj.key = uuid();
        }
        loadFunction[modulesObj.key] = modulesObj;
    }
    // 事件监听
    initEmitEvent(stageCanvas) {

        let $functions = loadFunction;
        if ($functions) {
            Object.keys($functions).forEach(key => {
                let funcKey = jsToken + '__' + key;
                stageCanvas.on($functions[funcKey].value, (evt) => {
                    $functions[funcKey].func.call(this, evt)
                })
            })
        }

        globalThis.callFunc = (funcName) => {
            if (typeof funcName !== 'string') return;
            funcName.split(',').forEach(func => {
                this.callFunc(func)
            })

        }

        this.stageCanvas.socketFn = this.socketFn


        /* this.stageCanvas.on('valueUpdate', (val) => {
            console.log('pen属性更新', val)
        }) */
    }
    /**
     * 触发对应模块函数
     * @private
     * @param {string} name 
     */
    callFunc(name) {
        for (let key in $functions) {
            let funcKey = jsToken + '__' + key;
            if ($functions[funcKey].name == name) {
                $functions[funcKey].func.call(this)
            }
        }
    }



    /**
     * 注册图形库
     */
    registerDraw(stageCanvas) {
        // 注册表单
        stageCanvas.registerCanvasDraw(TopologyEngine.formPens())
        // 注册流程图
        stageCanvas.registerCanvasDraw(TopologyEngine.flowPens())
        // 注册图表
        stageCanvas.registerCanvasDraw(TopologyEngine.chartsPens())

        //    注册echarts
        TopologyEngine.registerEcharts(echarts)
        // 注册粒子发射器
        stageCanvas.registerCanvasDraw({ particle })

        // 注册控制面板
        stageCanvas.register({ DeviceController })

        // 注册3d模型
        stageCanvas.register({ ThreeModel })

        // 注册地图
        stageCanvas.register({ AMapLibs })

        // 注册二维码生成
        stageCanvas.register({ qrcode })
    }
    /**
     * 拷贝组件
     * @param {Array<T>|Object<T>} o 
     * @param {Boolean} keepCalc 
     * @returns {T}
     */
    deepClone(o, keepCalc = false) {
        if (Array.isArray(o)) {
            const arr = [];
            o.forEach((item) => {
                arr.push(this.deepClone(item, keepCalc));
            });
            return arr;
        } else if (typeof o === 'object') {
            if (o === null) {
                return null;
            } else if (o.constructor === RegExp) {
                return o;
            }
            const _o = {};
            for (const key in o) {
                if (
                    ['canvas', 'lastFrame'].includes(key) ||
                    o[key] instanceof HTMLImageElement ||
                    o[key] instanceof HTMLMediaElement
                ) {
                    continue;
                } else if (key === 'calculative' && !keepCalc) {
                    continue;
                }
                _o[key] = this.deepClone(o[key], keepCalc);
            }
            return _o;
        }

        return o;
    }


    /**
     * 舞台画布
     */
    stageCanvas = null;
    /**
     * 
     * @param {string} tag 容器的class
     * @param {object} options 可选配置
     */
    createStage(tag, options = { rule: true, grid: true }) {
        this.stageCanvas = new this.Topology(tag, options);
        this.emit('stage-created', this.stageCanvas);
        this.registerDraw(this.stageCanvas)
        this.initEmitEvent(this.stageCanvas)
        console.log('stageCanvas', this.stageCanvas)
        return this.stageCanvas;
    }
    /**
     * @private
     * @param {object} msgObj 
     * @returns {string}
     */
    msgFormat(msgObj) {
        return JSON.stringify(msgObj) + '\r\n'
    }
    /**
     * 保存配置
     */
    async saveConfig() {
        let list = await storage.getItem('technologyConfig') || {}
        let auth = this.proc.make('Auth');
        let config = JSON.stringify(this.stageCanvas.data());
        let device = auth.device;
        if (!device) {
            return Promise.reject('没有找到相关设备')
        }
        if (list[device.deviceNo]) {
            // 复制一份保存到历史记录
            this.historyTopoConfig(device.deviceNo, JSON.parse(JSON.stringify(list[device.deviceNo])))
        }
        list[device.deviceNo] = config;
        storage.setItem('technologyConfig', list)
        return config;
    }

    // 保存历史记录
    async historyTopoConfig(deviceNo, list) {
        let history = await storage.getItem('historyTopo') || {};
        let device = this.proc.data.device;
        if (!history[deviceNo]) {
            history[deviceNo] = [];
        }
        let obj = {
            time: new Date(),
            deviceNo,
            deviceName: device.deviceName,
            data: list
        }
        if (history[deviceNo].length > 100) {
            history[deviceNo].pop();
        }
        history[deviceNo].unshift(obj)
        storage.setItem('historyTopo', history)
    }

    /**
     * 
     * @returns 获取历史记录
     */
    getHistoryTopoConfig() {
        return storage.getItem('historyTopo');
    }

    /**
     * 发送消息
     */
    sendMsg(data) {
        this.stageCanvas.mqttClient.publish(this.store.data.mqttTopics, this.msgFormat(data));
    }
    /**
     * @private
     * @param {any} message 
     */
    socketFn(message) {
        console.log(message)
    }

    /**
     * 获取配置
     */
    async getConfig() {
        let list = await storage.getItem('technologyConfig') || {}
        let auth = this.proc.make('Auth');
        let device = auth.device;
        if (!device || !list[device.deviceNo]) {
            return Promise.reject('没有找到相关设备')
        }
        return JSON.parse(list[device.deviceNo])
    }

    /**
     * 获取加密的配置文件
     */
    async enConfig() {
        let res = await this.getConfig()
        return encrypt.encrypt(JSON.stringify(res), decryptKey)
    }

    /**
     * 获取所有配置文件
     * @returns {Promise<object>}
     */
    async getConfigAll() {
        let configs = await storage.getItem('technologyConfig') || {}
        for (let key in configs) {
            try {
                if (typeof configs[key] == 'string') {
                    configs[key] = JSON.parse(configs[key])
                }
            } catch (error) {
                continue;
            }
        }
        return configs
    }



    /**
     * 组合为组件
     * @returns 返回组合的组件对象
     */
    toComponent() {

        const active = this.store.active;
        const allPens = this.store.data.pens;
        /** @type {Array} */
        const pens = active.length ? this.stageCanvas.toComponent(active) : this.stageCanvas.toComponent(allPens);
        const image = active.length ? this.stageCanvas.activeToPng() : this.stageCanvas.toPng();
        /** @type {Array} */
        let newCombinePens = [];
        pens.forEach((item) => {
            let name = item.name;
            // 如果是组合,且选中了组件
            if (name === 'combine' && item.children && active.length) {
                item.children.forEach(id => {
                    // 如果列表中不存在组件需要的子组件
                    if (!pens.some((e) => e.id == id)) {
                        let cPen = allPens.find(r => r.id === id)
                        if (cPen) {
                            newCombinePens.push(this.deepClone(cPen))
                        }
                    }
                })
                if (Reflect.has(item, 'showChild') && item.showChild == undefined) {
                    item.showChild = 0;
                }
            }
            newCombinePens.push(item)
        })
        let id = uuid()
        const obj = {
            name: pens[0]?.name || id,
            id: id,
            image,
            data: newCombinePens
        };
        this.TopoComponents.components = obj;
        this.emit('add.components', obj);
        return obj
    }
    /**
     * 删除组件
     * @param {string} id 删除的组件id
     */
    removeComponent(id) {
        let components = self.TopoComponents.components;
        let index = components.findIndex(item => item.id == id)
        if (index != -1) {
            self.TopoComponents.removeComponent(id)
            self.emit('remove.components', id)
        }
    }

    /**
     * @typedef component
     * @type {object}
     * @property {string} name 组件名
     * @property {string} image 图片
     * @property {string} id id
     * @property {Array} data 组件详细数据
     */

    /**
     * 更新组件
     * @param {component} pen 
     */
    updateComponent(pen) {
        let components = self.TopoComponents.components;
        let index = components.findIndex(item => item.id == pen.id)
        if (index != -1) {
            self.TopoComponents.components = pen
            self.emit('update.components', pen)
        }
    }

    /**
     * 复制选中的画笔
     */
    copy() {
        self.stageCanvas.copy();
    }
    /**
     * 粘贴复制的画笔
     */
    paste() {
        self.stageCanvas.paste();
    }

    /**
     * 撤消
     */
    undo() {
        self.stageCanvas.undo();
    }
    /**
     * 重做
     */
    redo() {
        self.stageCanvas.redo();
    }
    // 是否置底
    isBottom(id, bool = false) {
        self.stageCanvas.setValue({
            id: id,
            isBottom: bool
        })
    }

    /**
     * 置顶
     */
    top() {
        let active = self.store.active
        active.forEach(item => {
            self.isBottom(item.id, false)
            self.stageCanvas.top(item);
        })
        self.stageCanvas.render()
    }
    /**
     * 置底
     */
    bottom() {
        let active = self.store.active
        active.forEach(item => {
            self.isBottom(item.id, true)
            self.stageCanvas.bottom(item);
        })
        self.stageCanvas.render()
    }

    /**
     * 上移一层
     */
    up() {
        let active = self.store.active
        active.forEach(item => {
            if (item.image) {
                self.isBottom(item.id, false)
            }

            self.stageCanvas.up(item);
        })
        self.stageCanvas.render()
    }
    /**
     * 下移一层 
     */
    down() {
        let active = self.store.active
        active.forEach(item => {
            if (item.image) {
                self.isBottom(item.id, true)
            }

            self.stageCanvas.down(item);
        })
        self.stageCanvas.render()
    }
    /**
     * 删除
     */
    delete() {
        let active = self.store.active
        self.stageCanvas.delete(active);
    }
    // 锁定状态
    LockState = {
        // 未锁定
        None: 0,
        // 禁止编辑，隐藏大小、缩放、选中编辑框；可选中、高亮、移动、触发事件等
        DisableEdit: 1,
        // 禁止编辑 + 移动；可选中、高亮、触发事件等
        DisableMove: 2,
        //不触发任何操作和事件
        Disable: 10,
    }
    /**
     * 锁定画笔
     */
    lock() {
        let active = self.store.active;
        active.forEach(item => {
            if (item.locked == self.LockState.Disable) {
                item.locked = self.LockState.None;
            } else {
                item.locked = self.LockState.Disable;
            }
        })
        // self.stageCanvas.setValue(active);
    }

    /**
     * 组合画笔
     */
    combine(state) {
        let actives = self.store.active;
        if (state) {
            self.stageCanvas.combine(actives, state);
            return;
        }
        self.stageCanvas.combine(actives);
    }
    /**
     * 组合为状态
     */
    combineState() {
        let actives = self.store.active;
        self.stageCanvas.combine(actives, 0);
    }
    /**
     * 取消组合
     */
    uncombine() {
        let active = self.store.active;
        active.forEach(item => {
            self.stageCanvas.uncombine(item);
        })
    }

    copyStyle() {
        let active = self.store.active;
        let obj = {
            lineWidth: 0,
            globalAlpha: 1,
            borderRadius: 0,
            textColor: '',
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 1,
            textAlign: 'center',
            textBackground: '',
            color: '',
            background: '',
            disableAnchor: true,
            paddingTop: 0,
            paddingBottom: 0,
            paddingLeft: 0,
            paddingRight: 0,
        }

        Object.keys(active[0]).forEach(key => {
            if (Reflect.has(obj, key)) {
                obj[key] = active[0][key]
            }
        })
        self.proc.data.copyStyle = obj;
    }
    pasteStyle() {
        if (self.proc.data.copyStyle) {
            let active = self.store.active;
            active.forEach(item => {
                let obj = {}
                Object.keys(self.proc.data.copyStyle).forEach(key => {
                    obj[key] = self.proc.data.copyStyle[key];
                })
                self.stageCanvas.setValue({
                    id: item.id,
                    ...obj
                });
            })

        }
    }

    /*获取指定的event*/
    getEvent(uuid) {
        let spriteEvents = this.data.spriteEvents
        for (let i = 0; i < spriteEvents.length; i++) {
            if (spriteEvents[i].uuid == uuid) {
                return spriteEvents[i]
            }
        }
        return null;
    }
    /**
     * 清空舞台数据并清除已保存的数据
     */
    clear() {
        this.stageCanvas.clear()
        storage.removeItem('technologyConfig')
    }
    /**
     * 清空舞台
     */
    clearStage() {
        this.stageCanvas.clear()
    }
    /**
     * 生成随机ID
     * @returns {string}
     */
    rid() {
        return Math.random().toString(36).substring(2);
    }
    /**
     * 下载配置
     */
    download() {
        let data = this.stageCanvas.data();
        data._device = this.proc.data.device;
        if (!this.proc.data.device) {
            alert('未选择相应的设备')
            return
        };

        let config = JSON.stringify(data);
        let downloadUrl = URL.createObjectURL(new Blob([encrypt.encrypt(config, decryptKey)], {
            type: 'text/plain'
        }));
        // this.unConfig()
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.download = `${this.proc.data.device.deviceName}_${this.proc.data.device.deviceNo}_${Date.now()}.topo`;
        link.click();
        link.remove()
    }
    /**
     * 解密配置文件
     * @param {String} config 加密的字符串
     * @returns {Object}
     */
    deConfig(config) {
        try {
            let enConfig = JSON.parse(encrypt.decrypt(config, decryptKey));
            return enConfig
        } catch (error) {
            return null
        }
    }

    // 第一次更新时，需要先更新一次，否则无法获取到画笔的初始值
    firstUpdate = {};

    /**
     * 数据更新绑定
     * @param {Array} modules 所有模块的数据
     * @returns 
     */
    update(modules = []) {
        let pens = this.store.data.pens; //舞台上所有的画笔

        if (!pens) return;
        for (let item of pens) {
            // 获取画笔下的自定义属性，用于判断是否存在数据更新
            let form = item.form;

            if (!form || !form.length) continue;
            try {
                for (let i = 0; i < form.length; i++) {
                    const key = form[i].key; //需要更新的pen上的属性值
                    const dataIds = form[i]?.dataIds;
                    const bindKey = dataIds && dataIds.key;

                    if (Reflect.has(item, key)) {
                        let id = form[i].id;
                        let moduleObj = modules.find(_module => _module.id == id);

                        if (!moduleObj) continue;
                        // 使用setValue触发一次值更新事件
                        if (!this.firstUpdate[item.id]) {
                            this.stageCanvas.setValue({
                                id: item.id
                            });
                            this.firstUpdate[item.id] = true;
                        }
                        // 如果原先值不等于更新值则更新数据
                        if (bindKey && (item[key] !== moduleObj[bindKey]) && moduleObj[bindKey] !== undefined && moduleObj[bindKey] !== null) {
                            // pens[item][key] = form[i].value = moduleObj[key]; //将指定key的值更新到画笔上，直接复制无法触发数据更新事件
                            // console.log('数据更新', item.id,'=', key,'=', moduleObj[bindKey])
                            this.stageCanvas.setValue({
                                id: item.id,
                                [key]: moduleObj[bindKey]
                            });
                        }
                    }
                }
            } catch (error) {
                console.log(error)
            }
        }
    }

    /**
     * 舞台的数据
     */
    get store() {
        return this.stageCanvas.store || null;
    }
}